
import React, { useEffect } from "react";
import {
  Pagination as PolarisPagination,
  Text,
  BlockStack,
} from "@shopify/polaris";
import usePagination from "../hooks/usePagination";

const Pagination = ({
  products,
  setCurrentProducts,
  productPerPage = 20,
  setIndexing,
  indexing = 1,
  currentProducts,
}) => {
  const { currentPage, nextPage, previousPage, pageNumbers } = usePagination(
    products,
    setCurrentProducts,
    productPerPage,
    setIndexing
  );

  useEffect(() => {
    setIndexing?.(currentPage);
  }, [currentPage, setIndexing]);

  if (!currentProducts || currentProducts.length === 0) {
    return null;
  }

  const totalPages = pageNumbers.length;
  const hasPrevious = currentPage > 1;
  const hasNext = currentPage < totalPages;

  return (
    <BlockStack align="center" gap="400">
      <PolarisPagination
        label={
          <Text variant="bodyMd" fontWeight="medium">
            Page {currentPage} of {totalPages}
          </Text>
        }
        hasPrevious={hasPrevious}
        onPrevious={previousPage}
        hasNext={hasNext}
        onNext={nextPage}
        previousKeys={[74]}      
        previousTooltip="j"        
        nextKeys={[75]}              
        nextTooltip="k"
        previousLabel="Previous page"
        nextLabel="Next page"
        accessibilityLabel={`Page ${currentPage} of ${totalPages}`}
      />
    </BlockStack>
  );
};

export default Pagination;